import { Component, Prop, h } from '@stencil/core';
import { Business, WidgetStyle } from '../../../types';

@Component({
  tag: 'hemfixarna-skanska',
  styleUrl: 'hemfixarna-skanska.scss',
  shadow: true,
})
export class MyComponent {
  @Prop() id?: string;
  @Prop() widgetStyle?: WidgetStyle = WidgetStyle.standard;
  @Prop() buttonColor?: string;
  @Prop() buttonBg?: string;

  render() {
    return (
      <hemfixarna-component widgetStyle={this.widgetStyle} buttonBg={this.buttonBg} buttonColor={this.buttonColor} id={this.id} business={Business.skanska}></hemfixarna-component>
    );
  }
}
